import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { activeProfileRoles, isGuardOnlyProfile } from '../lib/guardProfile';

export function resolveRoleLanding(user) {
  const roles = activeProfileRoles(user);
  if (isGuardOnlyProfile(user)) return '/ares-seguridad/caseta';
  if (user?.is_direccion || roles.includes('direccion')) return '/direccion/resumen';
  if (roles.includes('consejo') && !roles.some((role) => ['administrador', 'supervisor'].includes(role))) return '/consejo';
  if (roles.includes('administrador') || roles.includes('supervisor')) return '/dashboard';
  if (roles.includes('mantenimiento')) return '/mantenimientos';
  if (roles.includes('jardineria')) return '/checklists';
  return '/dashboard';
}

export default function RoleLandingRedirect() {
  const { user } = useAuth();
  const location = useLocation();
  const query = location.search || '';
  return <Navigate to={`${resolveRoleLanding(user)}${query}`} replace />;
}
